// API endpoints for Document Upload operations

export const uploadDocumentUrl = (customerId: string): string => {
  return `/documents/${customerId}/upload`;
};

export const getDocumentsUrl = (customerId: string): string => {
  return `/documents/${customerId}`;
};

export const deleteDocumentUrl = (
  customerId: string,
  documentId: string,
): string => {
  return `/documents/${customerId}/${documentId}`;
};
